export interface FastPayments {
    paymentId: {
        id: string;
    };
    paymentSystem: string;
    pikPaymentId: string;
    person: {
        id: string;
        name: string;
    };
    fees: {
        totalFee: number;
        taxFeeSum: number;
        postalFeeSum: number;
        administrativeFeeSum: number;
    };
    items: [
        {
            documentType: string;
            administrativeFee: number;
            taxFee: number;
            postalFee: number;
            quantity: number;
            version: string;
        }
    ];
    commitmentId: {
        commitmentId: string;
    };
    paymentStatus: FastPaymentStatus;
    idr: {
        value: string;
    };
    redirectUrl: string;
    hotpConfirmation: string;
}

export enum FastPaymentStatus {
    AUTHPENDING = 'AUTHPENDING',
    AUTHACCEPTED = 'AUTHACCEPTED',
    AUTHREJECTED = 'AUTHREJECTED',
    EXCEEDED = 'EXCEEDED'
}